export const newItems = [
  {
    key: 'PBRK',
    value: 'PBRK',
    text: 'PBRK - Breakfast Payment',
  },
  {
    key: 'PLUN',
    value: 'PLUN',
    text: 'PLUN - Lunch Payment',
  },
  {
    key: 'POTH',
    value: 'POTH',
    text: 'POTH - Other Payment',
  },
  {
    key: 'PEOY',
    value: 'PEOY',
    text: 'PEOY - End of Year',
  },
  {
    key: 'PPUR',
    value: 'PPUR',
    text: 'PPUR - Purchase Adjustment',
  },
  {
    key: 'PPAY',
    value: 'PPAY',
    text: 'PPAY - Payment Adjustment',
  },
  {
    key: 'PLPP',
    value: 'PLPP',
    text: 'PLPP - LunchPrepay Payment',
  },
  {
    key: 'PTRF',
    value: 'PTRF',
    text: 'PTRF - Balance Transfer',
  },
  {
    key: 'PUTL',
    value: 'PUTL',
    text: 'PUTL - Balance Change Utility',
  },
  {
    key: 'PARC',
    value: 'PARC',
    text: 'PARC - Archived History',
  },
  {
    key: 'PCRE',
    value: 'PCRE',
    text: 'PCRE - Credit Payment',
  },
  {
    key: 'PSUP',
    value: 'PSUP',
    text: 'PSUP - Supper Payment',
  },
  {
    key: 'PDEL',
    value: 'PDEL',
    text: 'PDEL - Deleted Student Adjustment',
  },
  {
    key: 'PZBU',
    value: 'PZBU',
    text: 'PZBU - Zero Balance Utility',
  },
];



// WEBPACK FOOTER //
// ./src/common/Constants/newItems.js